import React from 'react';
import { useHistory } from 'react-router-dom';
import { APP_FEATURE_CONFIG } from 'src/config/constant';
import { useAmzDspContext } from 'src/contexts/AmzDspContext';

const DspPlatformFeeAccessGuard = ({ children }) => {
  const history = useHistory();
  const selectedProfileId = JSON.parse(sessionStorage.getItem('selectedProfileId'));
  const availablePermission = selectedProfileId?.permissions || []
  const isAmazon = window.location.href.indexOf('/amazon') > -1
  const { amzDspState } = useAmzDspContext();
  if(Number(amzDspState?.walletBalance) < 0 && (amzDspState?.activeTab === 1 || amzDspState?.activeTab === 2)) {
        history.push('/amazon-dsp/restricted', { deniedPage: 'platform-fee' });
        return null;
  }

  return <React.Fragment>{children}</React.Fragment>;

};

export default DspPlatformFeeAccessGuard;